import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import "./membrModal.scss";
import { NavLink } from "react-router-dom";
import axios from "axios";
import { useState } from "react";
import x from "../../assets/xWhite.svg";

function MemberModal() {
  const id = JSON.parse(window.localStorage.getItem("logId"));
  const expLog = JSON.parse(window.localStorage.getItem("expLog"));

  const [data, setData] = useState();

  const getData = async () => {
    const result = await axios.get(`https://mobile.amospa.com/users/${id}`);
    setData(result.data.data[0].name);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="memberModal" style={{overflow:'scroll'}}>
      <div className="wrapperModalMember">
        <div className="header">
          <h4>{data} ~ History Log</h4>
          <NavLink to={"/homepage/members/"}>
            <img src={x} alt="" />
          </NavLink>
        </div>
        
        <div className="content">
          <ul>
            <NavLink
              to={"/homepage/members/log/"}
              style={{ textDecoration: "none" }}
              className={({ isActive }) =>
                isActive ? "active-log-member" : "non-active-log-member"
              }
            >
              <li className="li-info">Info</li>
            </NavLink>
            <NavLink
              to={"/homepage/members/log/profile/"}
              style={{ textDecoration: "none" }}
              className={({ isActive }) =>
                isActive ? "active-log-member" : "non-active-log-member"
              }
            >
              <li>Profile Data</li>
            </NavLink>
            <NavLink
              to={"/homepage/members/log/photo/"}
              style={{ textDecoration: "none" }}
              className={({ isActive }) =>
                isActive ? "active-log-member" : "non-active-log-member"
              }
            >
              <li>Photo</li>
            </NavLink>
            <NavLink
              to={"/homepage/members/log/extend"}
              style={{ textDecoration: "none" }}
              className={({ isActive }) =>
                isActive ? "active-log-member" : "non-active-log-member"
              }
            >
              <li>Extend</li>
            </NavLink>
            <NavLink
              to={"/homepage/members/log/history"}
              style={{ textDecoration: "none" }}
              className={({ isActive }) =>
                isActive ? "active-log-member" : "non-active-log-member"
              }
            >
              <li className="li-log">Log</li>
            </NavLink>
          </ul>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default MemberModal;
